import { useSelector } from 'react-redux';
import { selectedFspIdSelector } from 'selectors/fsp';

const useSelectedFSPId = () => {
  return useSelector(selectedFspIdSelector);
};

export default useSelectedFSPId;
